export default __webpack_public_path__ + "static/media/home-publications-vector.14d53eb6.svg";